import { Fragment, useId, useState, type ReactNode } from 'react';

/** 表の意味構造を保ち、ボタンは Enter / Space、行全体はクリックで開閉する。 */
export function ExpandableRow({
  label,
  columns,
  children,
  className = '',
  defaultOpen = false,
}: {
  label: string;
  columns: ReactNode[];
  children: ReactNode;
  className?: string;
  defaultOpen?: boolean;
}) {
  const id = useId();
  const [open, setOpen] = useState(defaultOpen);
  return (
    <Fragment>
      <tr
        className={`activity-row ${className}`}
        onClick={(event) => {
          if ((event.target as HTMLElement).closest('a, button, input, select')) return;
          setOpen(!open);
        }}
      >
        <td className="activity-toggle-cell">
          <button
            type="button"
            className="btn small activity-toggle"
            aria-label={label}
            aria-expanded={open}
            aria-controls={`${id}-details`}
            onClick={() => setOpen(!open)}
          >
            <span aria-hidden="true">{open ? '▾' : '▸'}</span>
          </button>
        </td>
        {columns.map((column, index) => (
          <td key={index}>{column}</td>
        ))}
      </tr>
      {open && (
        <tr className="activity-details">
          <td colSpan={columns.length + 1}>
            <div id={`${id}-details`} role="region" aria-label={label} className="stack">
              {children}
            </div>
          </td>
        </tr>
      )}
    </Fragment>
  );
}
